// extracted by mini-css-extract-plugin
module.exports = {"List":"PageList_List__3E2uN","Level0":"PageList_Level0__1VDZs"};